export default "__VITE_ASSET__CiVtnu0___"